import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EnvironmentService } from './environment.service';
import { SignInRequest } from '../models/authorization/sign-in-request.model';
import { AuthenticatedUser } from '../models/authorization/authenticated-user.model';
import { HttpHelper } from '../helpers/http';
import { PinAuthenticationService } from './pin-authentication.service';
import { LocalStorageHelper } from '../helpers/local-storage';

@Injectable({
	providedIn: 'root',
})
export class SignInService {
	private currentAuthenticatedUserSubject: BehaviorSubject<AuthenticatedUser>;
	private signInEndpoint: string
	public currentAuthenticatedUser: Observable<AuthenticatedUser>;

	constructor(private http: HttpClient,
		private environmentService: EnvironmentService,
		private httpHelper: HttpHelper,
		private pinAuthenticationService: PinAuthenticationService,
		private localStorageHelper: LocalStorageHelper) {
			this.signInEndpoint = this.environmentService.getBaseUrl();
			this.currentAuthenticatedUserSubject = new BehaviorSubject<AuthenticatedUser>(JSON.parse(localStorage.getItem('currentAuthenticatedUser')));
			this.currentAuthenticatedUser = this.currentAuthenticatedUserSubject.asObservable();
	 }
	 

	public get currentAuthenticatedUserValue(): AuthenticatedUser {
		this.currentAuthenticatedUserSubject = new BehaviorSubject<AuthenticatedUser>(JSON.parse(localStorage.getItem('currentAuthenticatedUser')));
		return this.currentAuthenticatedUserSubject.value;
	}

	public get isUserAuthenticated(): boolean {
		let currentAuthedUser = JSON.parse(localStorage.getItem('currentAuthenticatedUser'));
		let currentDate = new Date();
		let currentUtcDate = new Date(currentDate.getTime() + currentDate.getTimezoneOffset() * 60 * 1000);

		if (currentAuthedUser === null || currentUtcDate > new Date(currentAuthedUser.expiration)) {
			return false;
		}
		else {
			return true;
		}
	}

	public signIn(signInRequest: SignInRequest): Observable<AuthenticatedUser> {
		return this.http.post<AuthenticatedUser>(this.signInEndpoint + `/api/authentication/account`,
			JSON.stringify(signInRequest),
			this.httpHelper.SetRequiredAwsHttpPostHeaders())
		.pipe(map(res => { 
			this.startUserSession(res);
			return res; 
		}));
	}

	removeUserSession() {
		localStorage.removeItem('currentAuthenticatedUser');
		this.currentAuthenticatedUserSubject.next(null);
	}

	public startUserSession(authenticatedUser: AuthenticatedUser, loginData: any = null) {
		localStorage.setItem('currentAuthenticatedUser', JSON.stringify(authenticatedUser));
		this.currentAuthenticatedUserSubject.next(authenticatedUser);

		if (loginData === null) return;

		if (loginData !== null && loginData.rememberMe) {
			this.localStorageHelper.saveRememberedCredentials(loginData.email);
		} else {
			this.localStorageHelper.clearRememberedCredentials();
		}
	}

	private isLoggedInViaBothAuthForms = false;
	public get loggedInBothWays(): boolean {
		return this.isLoggedInViaBothAuthForms;
	}
	
	// Called when UI needs to display extra navigation when logged in via both ways 
	// and viewing a diary thats not your own.
	public checkAndSetIsLoggedInToMultipleFormsOfAuth() {
		if (this.isUserAuthenticated && this.pinAuthenticationService.isAnonUserAuthenticated) {
			this.isLoggedInViaBothAuthForms = true;			
		} else {
			this.isLoggedInViaBothAuthForms = false;
		}
	}
}
